import { Typography } from '@snowball-tech/fractal/dist/src/components/Typography'

import type { ComponentProps } from 'react'
import PhotoAlbum from 'react-photo-album'

import isEmpty from 'lodash/fp/isEmpty'
import omit from 'lodash/fp/omit'

import useTranslations from '../../hooks/useTranslations'
import { GalleryImage } from '../../types'

type Props = {
  images: Array<GalleryImage>
  onImageClick: ComponentProps<typeof PhotoAlbum>['onClick']
  layout?: ComponentProps<typeof PhotoAlbum>['layout']
} & Partial<Omit<ComponentProps<typeof PhotoAlbum>, 'layout' | 'onClick'>>
export default function Gallery({
  images = [],
  layout = 'rows',
  onImageClick,
  ...galleryProps
}: Props) {
  const $t = useTranslations()
  if (isEmpty(images)) {
    return <Typography>{$t('image_picker.no_image')}</Typography>
  }

  const GalleryPhotoAlbum = PhotoAlbum<GalleryImage>

  return (
    <GalleryPhotoAlbum
      layout={layout}
      photos={images}
      renderPhoto={({ photo: image, renderDefaultPhoto, wrapperStyle }) => (
        <div
          className="relative flex justify-center text-center mb-3"
          style={omit(['display'], wrapperStyle)}
        >
          {renderDefaultPhoto({ wrapped: true })}

          <Typography
            className="absolute -bottom-3 truncate whitespace-nowrap max-w-full no-underline"
            href={image.parentPage}
            target="_blank"
            title={image.description ?? image.parentPage}
            variant="caption-link"
          >
            {image.description ?? image.parentPage}
          </Typography>
        </div>
      )}
      onClick={onImageClick}
      {...omit(['layout', 'onClick'], galleryProps)}
    />
  )
}
